import React, { useEffect, useState } from "react";
import "./styles.scss";
import moment from "moment";
import { GetIconByName } from "../../config/icon";
import {
  changeCommentLike,
  deleteNewsComment,
  updateNewsCommentStatus,
} from "../../containers/news/service/news.service";
import { Popconfirm } from "antd";
import { Store } from "react-notifications-component";
import { changeJobCommentLike } from "../../containers/GovernmentJobsPage/service/jobs.service";

const CommentCard = ({ data, comment, newsId, index, type, refresh }) => {
  const [likes, setLikes] = useState(comment?.likes || 0);
  const [dislikes, setDislikes] = useState(comment?.dislikes || 0);
  const [showReplyBox, setShowReplyBox] = useState(false);
  const [userLiked, setUserLiked] = useState("");
  const [userDisLiked, setUserDisLiked] = useState("");

  const commentKey = `comment_reaction_${comment?.comment_id}`;

  useEffect(() => {
    const alreadyReacted = localStorage.getItem(commentKey);
    console.log({ alreadyReacted });
    if (alreadyReacted === "liked") {
      setUserLiked(comment?.comment_id);
    }
    if (alreadyReacted === "disliked") {
      setUserDisLiked(comment?.comment_id);
    }
  }, []);

  const handleLike = async () => {
    const alreadyReacted = localStorage.getItem(commentKey);
    if (alreadyReacted) {
      alert("You have already rated this comment.");
      return;
    }
    try {
      let response = null;
      if (data?.type === "jobs") {
        response = await changeJobCommentLike(
          "like",
          comment?.comment_id,
          newsId
        );
      } else {
        response = await changeCommentLike("like", comment?.comment_id, newsId);
      }
      console.log("add News Comments::", response);
      if (response.data?.status) {
        setLikes(likes + 1);
        localStorage.setItem(commentKey, "liked");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDislike = async () => {
    const alreadyReacted = localStorage.getItem(commentKey);
    if (alreadyReacted) {
      alert("You have already rated this comment.");
      return;
    }
    try {
      let response = null;
      if (data?.type === "jobs") {
        response = await changeJobCommentLike(
          "dislike",
          comment?.comment_id,
          newsId
        );
      } else {
        response = await changeCommentLike(
          "dislike",
          comment?.comment_id,
          newsId
        );
      }
      console.log("add News Comments::", response);
      if (response.data?.status) {
        setDislikes(dislikes + 1);
        localStorage.setItem(commentKey, "disliked");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onclickHide = async () => {
    try {
      const response = await updateNewsCommentStatus(
        "hide",
        comment?.comment_id,
        newsId
      );
      console.log("add News Comments::", response);
      if (response.data?.status) {
        refresh(true);
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Comment hiding Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      console.error(error);
    }
  };

  const onClickDelete = async () => {
    try {
      const response = await deleteNewsComment(comment?.comment_id, newsId);
      console.log("add News Comments::", response);
      if (response.data?.status) {
        refresh(true);
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Comment delete Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      console.error(error);
      refresh(false);
    }
  };

  const onClickCancel = (e) => {
    console.log(e);
  };
  //   const handleReplyToggle = () => setShowReplyBox(!showReplyBox);

  return (
    <div className={`comment-card-wrapper`}>
      <div className={"ccw__img"}>{data.first_name?.slice(0, 1)}</div>
      <div>
        <div className={"ccw_header"}>
          {/* <div className={"d-flex flex-row align-items-center"}> */}
          <div className={"ccw_header_name"}>{data.first_name}</div>
          {type === "admin" && (
            <div className={"ccw_header_date ml-2"}>{data.email}</div>
          )}
          {/* </div> */}
          <div className={"ccw_header_date"}>
            {moment(comment?.created_at).startOf("minutes").fromNow()}
          </div>
        </div>
        <div className={"ccw_content"}>{data.comment}</div>
        <div
          className={
            "d-flex flex-row justify-content-between align-items-center"
          }
        >
          <div className={"ccw_actions"}>
            <div
              className={`ccwa_like click ${
                userLiked === comment?.comment_id ? "liked" : ""
              }`}
              onClick={type !== "admin" && handleLike}
            >
              {GetIconByName("like")}
              <span className={"ccwa_count"}>{likes}</span>
            </div>
            <div
              className={`ccwa_like click ${
                userDisLiked === comment?.comment_id ? "disliked" : ""
              } dislike`}
              onClick={type !== "admin" && handleDislike}
            >
              {GetIconByName("dislike")}
              <span className={"ccwa_count"}>{dislikes}</span>
            </div>
          </div>
          {/* <div className={"ccw__action"}>
            <Popconfirm
              placement="topLeft"
              title="Hide this Comment"
              description="Are you sure to hide this Comment?"
              onConfirm={onclickHide}
              onCancel={onClickCancel}
              okText="Yes"
              cancelText="No"
            >
              <div className={"ccw__a-link"}>Hide</div>
            </Popconfirm>
            <Popconfirm
              placement="topLeft"
              title="Delete the Comment"
              description="Are you sure to delete this Comment?"
              onConfirm={onClickDelete}
              onCancel={onClickCancel}
              okText="Yes"
              cancelText="No"
            >
              <div className={"ccw__a-link"}>Delete</div>
            </Popconfirm>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CommentCard;
